import ApiError from '../api/error/ApiError';
import UnauthorizedError from '../api/error/UnauthorizedError';

const validateUserAccessToDrupalPath = async (url: string): Promise<{ status: number }> => {
  // We make a quick request to the Drupal URL to check if it's a 403, 4xx or 5xx, anything 2xx or 3xx is considered acceptable
  // This is a same-origin request
  const response = await fetch(url, {
    method: 'HEAD',
    redirect: 'manual',
    credentials: 'include',
    headers: {
      Accept: 'application/xhtml+xml;q=0.9, text/html;q=0.8'
    }
  });

  const { status, headers } = response;
  const contentType = headers.get('Content-Type') || '';
  if (!contentType || !contentType.includes('html')) {
    throw new ApiError();
  }

  if (status === 403) {
    throw new UnauthorizedError();
  }

  if (status >= 400) {
    throw new ApiError();
  }

  return { status };
};

export { validateUserAccessToDrupalPath };
